import { render } from "./ColorSwitch.vue?vue&type=template&id=91d87aea&scoped=true"
import script from "./ColorSwitch.vue?vue&type=script&lang=js"
export * from "./ColorSwitch.vue?vue&type=script&lang=js"

import "./ColorSwitch.vue?vue&type=style&index=0&id=91d87aea&scoped=true&lang=stylus"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d87aea"]])

export default __exports__